import { render, staticRenderFns } from "./CatalogsMultiselect.vue?vue&type=template&id=e220fb74&scoped=true"
import script from "./CatalogsMultiselect.vue?vue&type=script&lang=js"
export * from "./CatalogsMultiselect.vue?vue&type=script&lang=js"
import style0 from "./CatalogsMultiselect.vue?vue&type=style&index=0&id=e220fb74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e220fb74",
  null
  
)

export default component.exports